// extracted by mini-css-extract-plugin
export default {"wrapper":"Disposal_wrapper__exd0v","actionCell":"Disposal_actionCell__LGhhW","deleteBtn":"Disposal_deleteBtn__xnnNU"};